/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-danger */
import * as React from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Modal } from '../..';
import { SaleReceipt } from '../../../pages/POSTeller/POSTeller';

export type PayOption = {
  customer: string;
  provider: string;
  identityNo: string;
  cardBrand?: string;
  cardLastFour?: string;
  cardExpiry?: string;
};

type ModalProps = {
  onCloseModal: () => void;
  onSendEmail: (email: string) => void;
  receipt: SaleReceipt;
};

function PrintReceipt({ onCloseModal, onSendEmail, receipt }: ModalProps) {
  const componentRef = React.useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      const getScrollHeight = (componentRef.current as any).contentWindow
        .document.body.scrollHeight;

      (componentRef.current as any).height = getScrollHeight;

      // (componentRef.current as any).contentWindow.print();
    },
    onAfterPrint: () => onCloseModal(),
  });

  const handleSendEmail = async () => {
    onSendEmail(receipt.customerEmail);
    onCloseModal();
  };

  return (
    <Modal onClose={onCloseModal} show>
      <div className="rounded-md bg-white w-full overflow-hidden relative min-h-[500px]">
        <div className="p-3 relative h-full flex flex-col">
          <div className="flex-1">
            <ComponentToPrint ref={componentRef} receiptHTML={receipt.html} />
          </div>
          <div className="flex flex-col items-center justify-center space-y-4 h-fit shrink-0 px-5 pt-5 pb-2">
            <Button
              label="Print"
              onClick={handlePrint}
              type="button"
              disabled={false}
              className="!bg-pos-green border border-[rgba(27,31,36,0.15)] min-w-[150px]  h-[40px]
                      items-center justify-center text-white text-xbase
                      shadow-[0_1px_0_rgba(27,31,36,0.1),inset_0_1px_0_rgba(255,255,255,0.03)] shrink-0 font-medium"
            />

            <Button
              label="Send As Email"
              onClick={handleSendEmail}
              type="button"
              className="!bg-[#f6f8fa] min-w-[150px] h-[40px] items-center justify-center 
              !text-pos-black text-xbase border border-[rgba(27,31,36,0.15)] 
              shadow-[0_1px_0_rgba(27,31,36,0.04),inset_0_1px_0_rgba(255,255,255,0.25)] font-medium"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

const ComponentToPrint = React.forwardRef<any, any>(
  ({ receiptHTML }: { receiptHTML: any }, ref) => {
    return (
      <iframe
        ref={ref}
        height={550}
        title="Official Receipt"
        srcDoc={receiptHTML}
      />
    );
  },
);

export default PrintReceipt;
